import axios from 'src/utils/axios';

const key = "commentCategories"

export const getCategories = async () => {
    let categories = localStorage.getItem(key);
    if (categories === null) {
        categories = await loadCategories();
        localStorage.setItem(key, JSON.stringify(categories));
        return categories;
    } else
        return JSON.parse(categories);
}


const loadCategories = async () => {
    return await axios.get("GetArtemisCommentCategories")
        .then(response => {
            return response.data;
        }).catch(() => {
            return [];
        })
}
